import FilterBlock from './FilterBlock';
import { useContext, useEffect, useState } from 'react';
import ShopContext from "^/ShopContext";
import RefineBy from './RefineBy';
import ax, { SEARCH_FILTER, SEARCH_MULTIPLE_FILTERS } from '%/axios';
import * as uf from '%/functions';

const filtersCategory = [
  'Color',
  'Price',
  'Shop By Vehicle'
];

const ProductFilters = () => {
  const [show, setShow] = useState(false);

  const {
    filters,
    selectedFilters,
    search,
    setProductResultsPagesTotal,
    setCatProdLoading,
    sort,
    initializeResults
  } = useContext(ShopContext);

  const IS_MOBILE = window.innerWidth < 768;

  const parsedList = Object.entries(filters).map(([key, value]) =>
    <FilterBlock
      category_name={key}
      list={value}
    />
  )

  useEffect(() => {
    // if (Object.keys(selectedFilters)?.length) {
    if (sort.selected || Object.keys(selectedFilters).length) {
      setCatProdLoading(true);
      const parsedFilters = uf.jsonToArray(selectedFilters);
      ax(parsedFilters.length > 1 ? SEARCH_MULTIPLE_FILTERS : SEARCH_FILTER, {
        qs: document.querySelector('#search_query')?.value,
        filters: parsedFilters,
        sort,
        category_id: CATEGORY_ID

      }).then(res => {
        setProductResultsPagesTotal(res)
        setCatProdLoading(false)
      }).catch(er => {
        setCatProdLoading(false)
        console.log(er)
      })
    } else {
      initializeResults();
    }
    // }
  }, [selectedFilters, sort])



  return IS_MOBILE ? (
    <>
      <div class="slideout-button"
        onClick={() => setShow(true)}
      >
        <span class="slideout-button-icon"></span>
        <span class="slideout-button-label">Filter Options</span>
      </div>
      {
        show &&
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            backgroundColor: 'rgba(0,0,0, 0.8)',
            width: '100vw',
            height: '100vh',
            zIndex: 999999
          }}
        >
          <div className='slideout-container'>
            <div className='filter-container open'
              style={{ maxWidth: 300, background: 'white' }}>
              <div class="slideout-header ng-scope">
                <h4 class="slideout-title">Filter Options</h4
                ><a
                  onClick={() => setShow(false)}
                  class="slideout-close" ></a>
              </div>
              {
                Object.keys(selectedFilters)?.length > 0 &&
                <RefineBy />
              }
              {parsedList}
            </div>

          </div>

        </div>
      }
    </>
  ) : (
    <aside className='filter-container'>
      {
        Object.keys(selectedFilters)?.length > 0 &&
        <RefineBy />
      }
      {parsedList}

    </aside>
  )
}

export default ProductFilters;
